// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__uDNTf","inputDescription":"styles_inputDescription__ghQw4"};